import { Box, Button, Grid, Stack, SxProps} from "@mui/material"
import { useReadPropertySpyListQuery } from "services/propertySpy"
import { PropertySpyCard } from "../../presentationals/PropertySpyCard"
import { PropertySpyFromResponse } from "shared/types/PropertySpyFromResponse"
import { Link } from "react-router-dom"

interface PropertySpyListCardListContainerProps {

}

export const PropertySpyListCardListContainer = (props: PropertySpyListCardListContainerProps): JSX.Element => {
    const {
        data: readMonitorsQueryData,
        isLoading: readPropertySpyListIsLoading,
        isFetching: readPropertySpyListIsFetching
    } = useReadPropertySpyListQuery({});

    const textStyle: SxProps = {
        fontSize: '20px'
    }

    const renderListCard = () => {
        if (readPropertySpyListIsFetching) {
            return (
                <>Loading</>
            )
        }

        if (readMonitorsQueryData !== undefined && readMonitorsQueryData.list.length === 0) {
            return (
                <Box sx={textStyle}>
                    <Box component="span">There are no properties selected to spy. First create a market spy and then choose properties to spy. Check here to </Box>
                    <Link to="/spy/create">
                        create market spy
                    </Link>  
                </Box>
            )
        }

        return (
            <div>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '26px 0 0 0',
                    }}
                >
                    <Stack direction="row" spacing={2}>
                        <Link to="/propertyspy/create">
                            <Button
                                variant="contained"
                                color="success"
                                sx={{
                                    minWidth: 330,
                                    minHeight: 48,
                                    fontSize: '20px',
                                    textTransform: 'capitalize'
                                }}
                            >
                                Create Property Spies
                            </Button >
                        </Link>
                    </Stack>
                </Box>
                <Grid container spacing={3} sx={{ margin: '0 0 0 0'}}>
                    {
                        readMonitorsQueryData?.list
                            .map((propertySpy: PropertySpyFromResponse) => {
                                return (
                                    <Grid item key={propertySpy.id}
                                        sx={{
                                            width: {
                                                xs: '100%',
                                                md: 'initial'
                                            }
                                        }}
                                    >
                                        <PropertySpyCard
                                            propertySpy={propertySpy}
                                            key={propertySpy.id}
                                        />
                                    </Grid>
                                )
                            })
                    }
                </Grid> 
            </div>        
        )
    }

    return (
        <Box>
            
            {
                renderListCard()
            }
        </Box>
    )
}